import React, { useState } from 'react';
import axios from 'axios';
import { LogIn, Key, UserPlus } from 'lucide-react';
import { API_BASE_URL } from './config';

function Login({ onLogin }) {
    const [email, setEmail] = useState('');
    const [sifre, setSifre] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const [ilkGiris, setIlkGiris] = useState(false);
    const [tempUser, setTempUser] = useState(null);
    const [yeniSifre, setYeniSifre] = useState('');
    const [yeniSifreTekrar, setYeniSifreTekrar] = useState('');
    const [kayitModu, setKayitModu] = useState(false);
    const [kayitEmail, setKayitEmail] = useState('');
    const [kayitSifre, setKayitSifre] = useState('');
    const [kayitSifreTekrar, setKayitSifreTekrar] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        try {
            const res = await axios.post(`${API_BASE_URL}/api/login`, { email, sifre });
            if (res.data.token) {
                localStorage.setItem('token', res.data.token);
            }
            if (res.data.ilk_giris) {
                setTempUser(res.data.kullanici);
                setIlkGiris(true);
            } else {
                localStorage.setItem('user', JSON.stringify(res.data.kullanici));
                onLogin(res.data.kullanici);
            }
        } catch (err) {
            setError(err.response?.data?.detail || 'Giriş başarısız!');
        }
    };

    const handleRegister = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');
        if (kayitSifre !== kayitSifreTekrar) {
            setError('Şifreler eşleşmiyor!');
            return;
        }
        if (kayitSifre.length < 4) {
            setError('Şifre en az 4 karakter olmalı!');
            return;
        }
        try {
            const res = await axios.post(`${API_BASE_URL}/api/register`, {
                email: kayitEmail,
                sifre: kayitSifre
            });
            setSuccess(res.data.mesaj);
            setKayitModu(false);
            setKayitEmail('');
            setKayitSifre('');
            setKayitSifreTekrar('');
        } catch (err) {
            setError(err.response?.data?.detail || 'Kayıt başarısız!');
        }
    };

    const handleSifreDegistir = async (e) => {
        e.preventDefault();
        setError('');
        if (yeniSifre !== yeniSifreTekrar) {
            setError('Şifreler eşleşmiyor!');
            return;
        }
        if (yeniSifre.length < 4) {
            setError('Şifre en az 4 karakter olmalı!');
            return;
        }
        try {
            await axios.post(`${API_BASE_URL}/api/sifre-degistir`, {
                kullanici_id: tempUser.id,
                yeni_sifre: yeniSifre
            });
            localStorage.setItem('user', JSON.stringify(tempUser));
            onLogin(tempUser);
        } catch (err) {
            setError(err.response?.data?.detail || 'Şifre değiştirme başarısız!');
        }
    };

    // Şifre değiştirme ekranı
    if (ilkGiris) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6' }}>
                <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
                    <h2 style={{ textAlign: 'center', marginBottom: '10px', color: '#1f2937' }}>
                        <Key size={28} style={{ verticalAlign: 'middle', marginRight: '10px' }} />
                        Şifre Değiştir
                    </h2>
                    <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '25px', fontSize: '14px' }}>
                        İlk girişiniz için yeni bir şifre belirlemelisiniz.
                    </p>
                    <form onSubmit={handleSifreDegistir}>
                        <input type="password" placeholder="Yeni Şifre" value={yeniSifre} onChange={e => setYeniSifre(e.target.value)} style={inputStyle} required />
                        <input type="password" placeholder="Yeni Şifre (Tekrar)" value={yeniSifreTekrar} onChange={e => setYeniSifreTekrar(e.target.value)} style={inputStyle} required />
                        {error && <p style={{ color: '#ef4444', marginBottom: '15px', textAlign: 'center' }}>{error}</p>}
                        <button type="submit" style={{ ...buttonStyle, backgroundColor: '#10b981' }}>Şifreyi Kaydet</button>
                    </form>
                </div>
            </div>
        );
    }

    // Kayıt ekranı
    if (kayitModu) {
        return (
            <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6' }}>
                <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
                    <h2 style={{ textAlign: 'center', marginBottom: '10px', color: '#1f2937' }}>
                        <UserPlus size={28} style={{ verticalAlign: 'middle', marginRight: '10px' }} />
                        Üye Ol
                    </h2>
                    <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '25px', fontSize: '14px' }}>
                        Kayıt sonrası admin onayı gereklidir.
                    </p>
                    <form onSubmit={handleRegister}>
                        <input type="email" placeholder="Email" value={kayitEmail} onChange={e => setKayitEmail(e.target.value)} style={inputStyle} required />
                        <input type="password" placeholder="Şifre" value={kayitSifre} onChange={e => setKayitSifre(e.target.value)} style={inputStyle} required />
                        <input type="password" placeholder="Şifre (Tekrar)" value={kayitSifreTekrar} onChange={e => setKayitSifreTekrar(e.target.value)} style={inputStyle} required />
                        {error && <p style={{ color: '#ef4444', marginBottom: '15px', textAlign: 'center' }}>{error}</p>}
                        <button type="submit" style={{ ...buttonStyle, backgroundColor: '#10b981' }}>Kayıt Ol</button>
                    </form>
                    <p style={{ textAlign: 'center', marginTop: '20px', color: '#6b7280' }}>
                        Zaten üye misiniz? <button onClick={() => { setKayitModu(false); setError(''); }} style={linkBtn}>Giriş Yap</button>
                    </p>
                </div>
            </div>
        );
    }

    // Giriş ekranı
    return (
        <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f3f4f6' }}>
            <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '16px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', width: '100%', maxWidth: '400px' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '30px', color: '#1f2937' }}>
                    <LogIn size={28} style={{ verticalAlign: 'middle', marginRight: '10px' }} />
                    Yangın Tüp Takip
                </h2>
                {success && <p style={{ color: '#10b981', marginBottom: '15px', textAlign: 'center', padding: '10px', backgroundColor: '#d1fae5', borderRadius: '8px' }}>{success}</p>}
                <form onSubmit={handleSubmit}>
                    <input type="email" placeholder="Email" value={email} onChange={e => setEmail(e.target.value)} style={inputStyle} required />
                    <input type="password" placeholder="Şifre" value={sifre} onChange={e => setSifre(e.target.value)} style={inputStyle} required />
                    {error && <p style={{ color: '#ef4444', marginBottom: '15px', textAlign: 'center' }}>{error}</p>}
                    <button type="submit" style={buttonStyle}>Giriş Yap</button>
                </form>
                <p style={{ textAlign: 'center', marginTop: '20px', color: '#6b7280' }}>
                    Hesabınız yok mu? <button onClick={() => { setKayitModu(true); setError(''); setSuccess(''); }} style={linkBtn}>Üye Ol</button>
                </p>
            </div>
        </div>
    );
}

const inputStyle = {
    width: '100%',
    padding: '12px 15px',
    marginBottom: '15px',
    border: '1px solid #ddd',
    borderRadius: '8px',
    fontSize: '16px',
    boxSizing: 'border-box',
    outline: 'none'
};

const buttonStyle = {
    width: '100%',
    padding: '12px',
    backgroundColor: '#3b82f6',
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 'bold',
    cursor: 'pointer'
};

const linkBtn = {
    background: 'none',
    border: 'none',
    color: '#3b82f6',
    fontWeight: 'bold',
    cursor: 'pointer',
    fontSize: '14px'
};

export default Login;


